const DELIVERY_STATUS_LABELS: Record<string, string> = {
  pending: "Pending",
  deferred: "Deferred",
  held: "Held for Review",
  sending: "Sending",
  delivered: "Delivered",
  failed: "Failed",
  cancelled: "Cancelled",
  recalled: "Recalled",
  ready_for_print: "Ready for Print",
  ready_for_pickup: "Ready for Pickup",
  printed: "Printed",
  mailed: "Mailed",
};

const DELIVERY_METHOD_LABELS: Record<string, string> = {
  email: "Email",
  fax: "Fax",
  hl7: "HL7",
  portal: "Portal",
  mail: "Print/Mail",
  print: "Print",
  remote_print: "Remote Print",
};

// Mirrors PORTAL_VISIBLE_STATUSES in the backend's physicianPortalController: the
// statuses at which a portal recipient can actually read the report. 'pending'
// is excluded because the delivery has not run — which is also how a suppressed
// delivery method withholds the report.
const PORTAL_AVAILABLE_STATUSES = new Set([
  "delivered",
  "sent",
  "viewed",
  "deferred",
  "held",
]);

export function isReportOnPortal(status: string): boolean {
  return PORTAL_AVAILABLE_STATUSES.has(status);
}

function formatUnderscoredLabel(value: string): string {
  return value
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (character) => character.toUpperCase());
}

export function formatDeliveryStatus(status: string): string {
  return DELIVERY_STATUS_LABELS[status] ?? formatUnderscoredLabel(status);
}

export function formatDeliveryMethod(method: string): string {
  const normalizedMethod = method.toLowerCase();
  return (
    DELIVERY_METHOD_LABELS[normalizedMethod] ?? formatUnderscoredLabel(method)
  );
}
